var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 .25v1.5h2.25v6.61L10.8 12l-4.55 3.64v6.61H4v1.5h16v-1.5h-2.25v-6.61L13.2 12l4.55-3.64V1.75H20V.25H4zm3.75 4h8.5v-2.5h-8.5v2.5zm0 12.11l4.25-3.4 4.25 3.4v3.08L12 16.04l-4.25 3.4v-3.08z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 .25v1.5h2.25v6.61L10.8 12l-4.55 3.64v6.61H4v1.5h16v-1.5h-2.25v-6.61L13.2 12l4.55-3.64V1.75H20V.25H4zm3.75 4h8.5v-2.5h-8.5v2.5zm0 12.11l4.25-3.4 4.25 3.4v3.08L12 16.04l-4.25 3.4v-3.08z",
    fill: "#6e6e6e",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e90a0a",
    d: "M0 0h6.27v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26221e",
    d: "M6.27 0h1v24h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff8600",
    d: "M6.98 0h6.46v24H6.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ae0000",
    d: "M13.44 0h4.22v24h-4.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0065b1",
    d: "M17.66 0h1v24h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008520",
    d: "M18.11 0H24v24h-5.89z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.03828efb5c88b69ad6889eb5f8fc969f.svg";
export { ForwardRef as ReactComponent };